import React, {useContext, useEffect, useState} from 'react';
import { AuthContext } from "../AuthContext";
import NewServiceForm from '../components/NewServiceForm'; // adjust path if needed
import Styles from '../styles/pages/ServicePlanner.module.css';
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import {load_fetch, isUserInRole} from "../pr_utils";
import SelectWorshipService from "../components/SelectWorshipService";
import ServiceViewer from "../components/ServiceViewer";
import OrderOfService from "../components/OrderOfService";
import NewSongForm from "../components/NewSongForm";
import SongManagerPanel from "../components/SongManagerPanel";
import SermonManagerPanel from "../components/SermonPanelManager";

const ServicePlanner = (props) => {
    const { authStatus } = useContext(AuthContext);
    const userRole = props.user_info?.role;
    const [activePanel, setActivePanel] = useState(null); // null | 'form' | 'selector'
    const [selectedService, setSelectedService] = useState(null);
    const [services, setServices] = useState([]);
    const [serviceElements, setServiceElements] = useState([]);
    const [songToEdit, setSongToEdit] = useState(null);
    const [movingElement, setMovingElement] = useState(false);
    const [allSongs, setAllSongs] = useState([]);
    const [allSermons, setAllSermons] = useState([]);
    const [selectedSermon, setSelectedSermon] = useState(null);
    const { search } = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(search);

    // Use Effects
    useEffect(() => {
        loadServices();
        getAllSongs();
        getAllSermons();
    }, []);

    useEffect(() => {
        const serviceId = queryParams.get("sid");
        const serviceDate = queryParams.get("sd");
        const songId = queryParams.get("edit_song");
        const service = serviceId
            ? findServiceById(serviceId)
            : serviceDate
                ? findServiceByDate(serviceDate)
                : null;

        if (songId && isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR'])) {
            const song = Object.values(allSongs).find(
                candidate => String(candidate.song_id) === String(songId)
            );

            if (song) {
                setSongToEdit(song);
                setSelectedService(null);
                setActivePanel('viewSongsPanel');
            }
            return;
        }

        if (service) {
            setSongToEdit(null);
            setSelectedService(service);
            setActivePanel('editingService');
            loadServiceElements(service.service_id);
        }
    }, [services, allSongs, search])

    const findServiceById = (serviceId) => {

        // Return if no services to search through
        if(!services || services.length === 0) {
            return null;
        }

        // Loop through and find the service
        for(let i = 0; i < services.length; i++) {
            if(String(services[i].service_id) === String(serviceId)) {
                return services[i];
            }
        }

        // Not Found
        return null;
    }

    const findServiceByDate = (serviceDate) => {

        // Return if no services to search through
        if(!services || services.length === 0) {
            return null;
        }

        // Loop through and find the service
        for(let i = 0; i < services.length; i++) {
            if(services[i].service_date === serviceDate) {
                return services[i];
            }
        }

        // Not Found
        return null;
    }


    // Ajax Functions
    const getAllSongs = async () => {
        let url = 'handlers/Service_Handler.php';

        let formData = {
            operation: 'GET_ALL_SONGS'
        }

        load_fetch(url, formData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                // Convert object to array
                const songArray = Object.values(data['DATA']);
                setAllSongs(songArray);
            } else {
                console.log(data);
            }
        });
    }
    const getAllSermons = async () => {
        let url = 'handlers/Service_Handler.php';

        let formData = {
            operation: 'GET_ALL_SERMONS'
        }

        load_fetch(url, formData, (data) => {

            if(!data['ERROR'] && !data['error']) {
                // Convert object to array
                const sermonArray = Object.values(data['DATA']);
                setAllSermons(sermonArray);
            } else {
                console.log(data);
            }
        });
    }
    const insertNewService = (formData) => {
        let url = 'handlers/Service_Handler.php';

        formData.operation = 'INSERT_NEW_SERVICE';

        load_fetch(url, formData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                setSelectedService(data['DATA']);
                loadServiceElements(data['DATA']['service_id'])
                loadServices();
                setActivePanel(null);
            } else {
                console.log(data);
            }
        });
    }
    const loadServices = () => {
        let url = 'handlers/Service_Handler.php';

        let formData = {
            operation: 'GET_ALL_SERVICES'
        }

        load_fetch(url, formData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                setServices(data['DATA']);
            } else {
                console.log(data);
            }
        });
    }

    const loadServiceElements = (service_id = selectedService['service_id']) => {
        let url = 'handlers/Service_Handler.php';

        let formData = {
            operation: 'GET_SERVICE_ELEMENTS',
            service_id: service_id
        }

        load_fetch(url, formData, (data) => {

            if(!data['ERROR'] && !data['error']) {
                setServiceElements(data['DATA']);
            } else {
                setServiceElements([]);
                console.log(data);
            }
        });
    }

    const moveElement = (element_id, direction) => {
        // If we are already moving an element, block repeat clicks before resolving first
        if(movingElement) {
            return;
        }

        // Lock movement
        setMovingElement(true);

        // Send to backend for processing
        let url = 'handlers/Service_Handler.php';

        let formData = {
            operation: 'MOVE_ELEMENT',
            service_id: selectedService['service_id'],
            direction: direction,
            service_element_id: element_id
        }

        load_fetch(url, formData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                setServiceElements(data['DATA']);
            } else {
                console.log(data);
            }
        });

        // Unlock movement
        setMovingElement(false);
    }
    const addServiceElement = (newElement) => {
        let url = 'handlers/Service_Handler.php';

        newElement.service_id = selectedService['service_id'];
        newElement.position = serviceElements.length + 1;
        newElement.operation = "INSERT_NEW_SERVICE_ELEMENT";

        load_fetch(url, newElement, (data) => {
            if(!data['ERROR'] && !data['error']) {
                setServiceElements(data['DATA']);
            } else {
                console.log(data);
            }
        });
    }
    const removeElement = (elementId) => {

        let url = 'handlers/Service_Handler.php';

        const formData = {
            operation: 'REMOVE_SERVICE_ELEMENT',
            elementId: elementId,
            serviceId: selectedService['service_id'],
        }

        load_fetch(url, formData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                setServiceElements(data['DATA']);
            } else {
                console.log(data);
            }
        })
    }
    const insertNewSong = (newSongInfo) => {
        let url = 'handlers/Service_Handler.php';

        newSongInfo.operation = "INSERT_NEW_SONG";

        load_fetch(url, newSongInfo, (data) => {
            if(!data['ERROR'] && !data['error']) {
                console.log("Song added");
                togglePanel(null);
            } else {
                alert("Song not added");
                console.log(data);
            }
        })
    }
    const insertNewSermon = async (newSermon) => {
        console.log(newSermon);

        if (!newSermon.title || !newSermon.title.trim()) {
            alert("Sermon title is required.");
            return;
        }

        let url = 'Sermon_Handler.php';

        const formData = {
            operation: 'INSERT_SERMON',
            title: newSermon.title,
            bible_text: newSermon.bible_text,
            description: newSermon.description,
            sermon_date: selectedService['service_date'],
            spotify_link: null,
            rumble_url: null,
            youtube_url: null
        };

        load_fetch(url, formData, (data) => {

            if(!data['ERROR'] && !data['error']) {
                console.log(data);
                setSelectedSermon(data['INSERTED_SERMON']); // set as selected
                setAllSermons(data['DATA']); // add to search pool
            } else {
                console.log(data);
            }
        });
    };











    // Other Functions
    const togglePanel = (panel) => {

        setSongToEdit(null);
        if(panel !== 'editingService' && panel !== 'selectServicePanel') {
            setSelectedService(null);
        }
        setActivePanel((prev) => (prev === panel ? null : panel));
    };

    const handleServiceSelect = (service) => {
        navigate(`/service_planner?sid=${encodeURIComponent(service.service_id)}`);
    };

    const updateSongList = (updatedSongList) => {
        setAllSongs(updatedSongList);
    }
    const editSongFromService = (songId) => {
        const song = Object.values(allSongs).find(
            candidate => String(candidate.song_id) === String(songId)
        );

        if (!song) {
            console.error(`Unable to find song ${songId} in the song list.`);
            return;
        }

        setSongToEdit(song);
        setSelectedService(null);
        setActivePanel('viewSongsPanel');
        navigate(
            `/service_planner?sid=${encodeURIComponent(selectedService.service_id)}` +
            `&edit_song=${encodeURIComponent(song.song_id)}`
        );
    }
    const updateSermonList = (updatedSermonList) => {
        setAllSermons(updatedSermonList);
    }

    // Block unauthenticated users or non-admins
    if (!authStatus || !isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR', 'SERVICE_VIEWER'])) {
        return <Navigate to="/" />;
    }

    return (
        <div className={Styles.container}>
            <h1 className={Styles.heading}>Service Planner</h1>
            <div className={Styles.buttonBar}>
                <button
                    onClick={() => togglePanel('newServiceForm')}
                    className={isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR']) ? `${Styles.menuButton} ${activePanel === 'newServiceForm' ? Styles.active : ''}` : Styles.hidden}
                >
                    Create New Service
                </button>
                <button
                    onClick={() => togglePanel('selectServicePanel')}
                    className={`${Styles.menuButton} ${activePanel === 'selectServicePanel' ? Styles.active : ''}`}
                >
                    Load Service
                </button>
                <button
                    onClick={() => togglePanel('addSongOrHymnPanel')}
                    className={isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR']) ? `${Styles.menuButton} ${activePanel === 'addSongOrHymnPanel' ? Styles.active : ''}` : Styles.hidden}
                >
                    Add Song/Hymn
                </button>
                <button
                    onClick={() => togglePanel('viewSongsPanel')}
                    className={isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR']) ? `${Styles.menuButton} ${activePanel === 'viewSongsPanel' ? Styles.active : ''}` : Styles.hidden}
                >
                    View/Edit Songs/Hymns
                </button>
                <button
                    onClick={() => togglePanel('viewSermonsPanel')}
                    className={isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR']) ? `${Styles.menuButton} ${activePanel === 'viewSermonsPanel' ? Styles.active : ''}` : Styles.hidden}
                >
                    View/Edit Sermons
                </button>
            </div>
            {activePanel === 'newServiceForm' && <NewServiceForm onSubmit={insertNewService}/>}
            {activePanel === 'selectServicePanel' &&
                <SelectWorshipService
                    onSelect={handleServiceSelect}
                    services={services}
                />}
            {activePanel === 'viewSongsPanel' &&
                <SongManagerPanel
                    songs={allSongs}
                    updateSongList={updateSongList}
                    initialSongToEdit={songToEdit}
                />
            }
            {activePanel === 'viewSermonsPanel' &&
                <SermonManagerPanel sermons={allSermons} updateSermonList={updateSermonList}/>
            }
            {selectedService &&
                <>
                    <ServiceViewer service={selectedService} />
                    <OrderOfService
                        service={selectedService}
                        serviceElements={serviceElements}
                        moveElement={moveElement}
                        addElement={addServiceElement}
                        removeElement={removeElement}
                        allSongs={allSongs}
                        allSermons={allSermons}
                        editSong={editSongFromService}
                        insertNewSermon={insertNewSermon}
                        selectedSermon={selectedSermon}
                        setSelectedSermon={setSelectedSermon}
                    />
                </>
            }
            {activePanel === 'addSongOrHymnPanel' && <NewSongForm onSubmit={insertNewSong} />}
        </div>
    );
}

export default ServicePlanner;
